import React from 'react'

export default function Eventsliner() {
  return (
    <div>
        <div className=' max-w-screen-md mx-auto py-5 text-md text-justify'>
        Frontend Overview: eventsliner

The frontend of the "Eventsliner" project has been meticulously crafted to deliver an intuitive and visually appealing user experience for a restaurant booking system. Here's an overview of the frontend technologies and features:

Next.js Framework :

The project leverages Next.js as the core framework for building React applications, providing a solid foundation for seamless navigation and efficient rendering.
Styling with Emotion and Tailwind CSS:

Emotion and Tailwind CSS are employed for styling React components, ensuring a responsive and aesthetically pleasing design throughout the application.
Material-UI Integration :

Material-UI is seamlessly integrated  to enhance the UI with pre-designed React components, ensuring a consistent and modern look and feel.
Icon Libraries:

MUI Icons  and React Icons (v4.8.0) are utilized for incorporating a diverse set of icons, contributing to the overall visual appeal and user interaction.
Responsive Design:

Tailwind CSS  plays a crucial role in achieving a responsive design, ensuring a seamless user experience across various devices and screen sizes.
Modal Components with React Modal:

React Modal is employed for creating modal components, enhancing user interactions and providing a polished interface for various actions within the application.
Toast Notifications using React Toastify:

React Toastify is integrated to display toast notifications, offering informative feedback to users during different interactions within the application.
In summary, the frontend of "eventsline-nextjs" showcases a blend of powerful frameworks and libraries, including Next.js, Emotion, Tailwind CSS, and Material-UI. The result is a visually appealing and user-friendly interface for the restaurant booking system, delivering a seamless and engaging user experience.
    </div>
    <a
            className="w-full text-center bg-teal-300 py-2"
            href="https://admin.eventsliner.com/"
            target="_blank"
            rel="noreferrer"
          >
            <button className='w-full text-center text-teal-900 font-bold text-md'>Live Site</button>
          </a>
    </div>
  )
}
